export const storeLastUsedProvider = (provider) => {
  localStorage.setItem("lastUsedProvider", provider);           
}
